import data from './data'
import components from './components'
import computed from './computed'
import mounted from './mounted'

export default {
  data,
  components,
  mounted,
  computed,
  resourcePath: '/v1/dweller/meetings'
}



// WEBPACK FOOTER //
// ./src/app/dweller/meeting/resources/index.js